"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));
var _Tooltip = _interopRequireDefault(require("@instructure/ui-overlays/lib/components/Tooltip"));
var _TruncateText = _interopRequireDefault(require("../TruncateText"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _dec2, _class, _class2, _temp;
var styles = {
  componentId: 'bZMhq',
  template: function template(theme) {
    return "\n\n.bZMhq_bGBk{align-items:center;background:".concat(theme.background || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";border-style:").concat(theme.borderStyle || 'inherit', ";border-width:").concat(theme.borderWidth || 'inherit', ";box-sizing:border-box;font-family:").concat(theme.fontFamily || 'inherit', ";height:").concat(theme.height || 'inherit', ";padding:").concat(theme.padding || 'inherit', "}\n\n.bZMhq_bGBk.bZMhq_daKB{outline:none;overflow:visible;position:relative}\n\n.bZMhq_bGBk.bZMhq_daKB:before{border:").concat(theme.focusOutlineWidth || 'inherit', " ").concat(theme.focusOutlineStyle || 'inherit', " ").concat(theme.focusOutlineColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";bottom:-0.375rem;box-sizing:border-box;content:\"\";display:block;left:-0.375rem;opacity:0;pointer-events:none;position:absolute;right:-0.375rem;top:-0.375rem;transform:scale(0.95);transition:all 0.2s}\n\n.bZMhq_bGBk.bZMhq_daKB.bZMhq_cVYB:before{opacity:1;transform:scale(1)}\n\n.bZMhq_eWKC{box-sizing:border-box;flex:1 0 auto;font-size:").concat(theme.textFontSize || 'inherit', ";font-weight:").concat(theme.textFontWeight || 'inherit', ";letter-spacing:0.0625rem;line-height:").concat(theme.lineHeight || 'inherit', ";max-width:").concat(theme.maxWidth || 'inherit', ";min-width:0.0625rem;text-align:center;text-transform:").concat(theme.textTransformStyle || 'inherit', "}\n\n[dir=ltr] .bZMhq_eWKC,[dir=rtl] .bZMhq_eWKC{text-align:center}\n\n.bZMhq_ddES{border-color:").concat(theme.color || 'inherit', "}\n\n.bZMhq_ddES .bZMhq_eWKC{color:").concat(theme.color || 'inherit', "}\n\n.bZMhq_bXiG{border-color:").concat(theme.primaryColor || 'inherit', "}\n\n.bZMhq_bXiG .bZMhq_eWKC{color:").concat(theme.primaryColor || 'inherit', "}\n\n.bZMhq_cOXX{border-color:").concat(theme.successColor || 'inherit', "}\n\n.bZMhq_cOXX .bZMhq_eWKC{color:").concat(theme.successColor || 'inherit', "}\n\n.bZMhq_zGXc{border-color:").concat(theme.dangerColor || 'inherit', "}\n\n.bZMhq_zGXc .bZMhq_eWKC{color:").concat(theme.dangerColor || 'inherit', "}\n\n.bZMhq_eRqw{border-color:").concat(theme.warningColor || 'inherit', "}\n\n.bZMhq_eRqw .bZMhq_eWKC{color:").concat(theme.warningColor || 'inherit', "}\n\n.bZMhq_elxg{border-color:").concat(theme.messageColor || 'inherit', "}\n\n.bZMhq_elxg .bZMhq_eWKC{color:").concat(theme.messageColor || 'inherit', "}");
  },
  'root': 'bZMhq_bGBk',
  'truncated': 'bZMhq_daKB',
  'focused': 'bZMhq_cVYB',
  'text': 'bZMhq_eWKC',
  'default': 'bZMhq_ddES',
  'primary': 'bZMhq_bXiG',
  'success': 'bZMhq_cOXX',
  'danger': 'bZMhq_zGXc',
  'warning': 'bZMhq_eRqw',
  'message': 'bZMhq_elxg'
};

/**
---
category: components
---
**/
var Pill = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Pill, _Component);
  function Pill(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Pill);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Pill).call(this, props));
    _this.state = {
      truncated: false
    };
    return _this;
  }
  (0, _createClass2.default)(Pill, [{
    key: "handleTruncation",
    value: function handleTruncation(truncated) {
      this.setState({
        truncated: truncated
      });
    }
  }, {
    key: "renderPill",
    value: function renderPill(focused, getTriggerProps) {
      var _classnames,
        _this2 = this;
      var _this$props = this.props,
        margin = _this$props.margin,
        text = _this$props.text,
        variant = _this$props.variant,
        as = _this$props.as,
        elementRef = _this$props.elementRef;
      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Pill.propTypes), Pill);
      var props = typeof getTriggerProps === 'function' ? getTriggerProps(passthroughProps) : passthroughProps;
      var classes = (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles.truncated, this.state.truncated), (0, _defineProperty2.default)(_classnames, styles.focused, focused), (0, _defineProperty2.default)(_classnames, styles[variant], variant), _classnames));
      return _react.default.createElement(_View.default, Object.assign({}, props, {
        className: classes,
        as: as,
        elementRef: elementRef,
        margin: margin,
        display: "inline-flex"
      }), _react.default.createElement("span", {
        className: styles.text
      }, _react.default.createElement(_TruncateText.default, {
        onUpdate: function onUpdate(truncated) {
          _this2.handleTruncation(truncated);
        }
      }, text)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.state.truncated) {
        return _react.default.createElement(_Tooltip.default, {
          tip: this.props.text
        }, function (_ref) {
          var focused = _ref.focused,
            getTriggerProps = _ref.getTriggerProps;
          return _this3.renderPill(focused, getTriggerProps);
        });
      } else {
        return this.renderPill();
      }
    }
  }]);
  Pill.displayName = "Pill";
  return Pill;
}(_react.Component), _class2.propTypes = {
  text: _propTypes.default.node.isRequired,
  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  variant: _propTypes.default.oneOf(['default', 'success', 'danger', 'primary', 'warning', 'message']),
  elementRef: _propTypes.default.func,
  as: _propTypes.default.elementType // eslint-disable-line react/require-default-props
}, _class2.defaultProps = {
  margin: void 0,
  elementRef: void 0,
  variant: 'default'
}, _temp)) || _class) || _class);
var _default = Pill;
exports.default = _default;